import { CustomVar, PricingOutputDTO } from 'src/services/reservation/pricing/pricingDTO'
import { getCustomVarsFromLiquidationRule } from 'src/components/pages/sales/reservation/helper/getCustomVarsFromLiquidationRule'
interface MyObject {
  pricing_relation: PricingOutputDTO[]
}

export const isCustomVarHidden = (customsVars: CustomVar[] | any[]) => {
  let exist = customsVars.find((elem: CustomVar) => elem.show === true)
  if (!exist) {
    return true
  }
  return false
}

export const isDisableEditLiquidationButton = (liquidationObject: MyObject) => {
  let liquidation = liquidationObject?.pricing_relation?.[0]?.liquidation_pricing?.liquidation
  let customsVars = getCustomVarsFromLiquidationRule(liquidation)
  if (customsVars === null) {
    return true
  } else {
    return isCustomVarHidden(customsVars)
  }
}
